import React from "react";
import { motion } from "framer-motion";
import Reveal from "./Reveal";
import { profile } from "../data/content";
import { FiMail, FiMessageCircle, FiGithub, FiLinkedin, FiInstagram, FiYoutube, FiArrowUpRight } from "react-icons/fi";

const SOCIAL_LINKS = [
  { label: "YouTube", href: profile.socials.youtube, icon: FiYoutube },
  { label: "LinkedIn", href: profile.socials.linkedin, icon: FiLinkedin },
  { label: "GitHub", href: profile.socials.github, icon: FiGithub },
  { label: "Instagram", href: profile.socials.instagram, icon: FiInstagram },
];

export default function Contact() {
  return (
    <section id="contact" className="section">
      <div className="container">
        <Reveal>
          <div
            className="card"
            style={{
              padding: "72px 48px",
              textAlign: "center",
              background:
                "linear-gradient(160deg, var(--surface) 0%, var(--surface-2) 60%, rgba(0,229,255,0.06) 100%)",
              position: "relative",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                position: "absolute",
                top: -120,
                right: -120,
                width: 320,
                height: 320,
                borderRadius: "50%",
                background: "radial-gradient(circle, rgba(168,85,247,0.25), transparent 70%)",
                pointerEvents: "none",
              }}
            />
            <div className="eyebrow" style={{ justifyContent: "center" }}>
              Let's Build Something
            </div>
            <h2 className="section-title" style={{ fontSize: "clamp(32px, 5vw, 54px)", marginBottom: 20, position: "relative" }}>
              Got a product idea, or want to <span className="gradient-text">learn to ship one?</span>
            </h2>
            <p style={{ color: "var(--text-muted)", fontSize: 18, maxWidth: 560, margin: "0 auto 40px", position: "relative" }}>
              Whether it's a startup MVP, scaling an existing product, or 1-on-1 mentorship — I'd love to hear about it.
            </p>

            <div style={{ display: "flex", flexWrap: "wrap", gap: 16, justifyContent: "center", marginBottom: 44, position: "relative" }}>
              <a href={`mailto:${profile.email}`} className="btn btn-primary">
                <FiMail size={18} /> {profile.email}
              </a>
              <a href={profile.whatsapp} target="_blank" rel="noreferrer" className="btn">
                <FiMessageCircle size={18} /> WhatsApp
              </a>
            </div>

            <div style={{ display: "flex", flexWrap: "wrap", gap: 12, justifyContent: "center", position: "relative" }}>
              {SOCIAL_LINKS.map((s) => (
                <motion.a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noreferrer"
                  whileHover={{ y: -4, borderColor: "var(--accent)" }}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    padding: "10px 18px",
                    borderRadius: 999,
                    border: "1px solid var(--border-strong)",
                    fontSize: 14,
                    color: "var(--text-muted)",
                  }}
                >
                  <s.icon size={15} /> {s.label} <FiArrowUpRight size={13} />
                </motion.a>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
